import React from 'react'
import PropTypes from 'prop-types'

class SaiToggle extends React.Component {
  state = {
    viewSaiOnly: this.props.viewSaiOnly
  }

  onChange = (e) => {
    this.setState({ viewSaiOnly: e.target.value })
    setTimeout(function() { this.props.newSaiToggleCallback(this.state.viewSaiOnly); }.bind(this), 300)
  }

  render() {
    const toggleOptions = [
      { label: "SAI Certifications", value: true },
      { label: "Non SAI Certifications", value: false }
    ];

    return(
      <div className='col-md-3 col-xs-12'>
        <select
          className='form-control'
          title='SAI Certification Toggle'
          value={this.state.viewSaiOnly}
          onChange={(e) => this.onChange(e)}
        >
          {toggleOptions.map(function(toggleOption) {
            return (
              <option
                key={toggleOption.label}
                value={toggleOption.value}
              >
              {toggleOption.label}
              </option>
            )
          })}
        </select>
      </div>
    )
  }
}

SaiToggle.propTypes = {
  viewSaiOnly: PropTypes.string,
  newSaiToggleCallback: PropTypes.func
}

export default SaiToggle
